import { styled } from '@linaria/react';
import { typographyStyles, COLORS } from '@livecommerce/design-system';

export const { getMediumHeadline, getBodyText } = typographyStyles;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% + 80px);
  height: calc(100% + 80px);
  margin: -40px;
  overflow: hidden;
`;

export const StyledImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: left top;
`;

export const CenteredBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  z-index: 1;
  width: 563px;
`;

export const Heading = styled.h1`
  ${getMediumHeadline(32)};
  margin: 0 0 20px;
`;

export const Note = styled.p`
  ${getBodyText(16)};
  margin: 0 0 16px;
  color: ${COLORS.dark_300};
`;

export const Description = styled.p`
  ${getBodyText(16)};
  margin: 0 0 20px;
`;

export const ButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  align-items: flex-start;
`;
